<template>
  <v-dialog persistent v-model="get_dialogAlertMain.dialog" :width="get_dialogAlertMain.withWindows" justify-center>
    <v-toolbar dense dark color="white">
      <v-toolbar-title>
        <h3 class="text-color-main" >{{ get_dialogAlertMain.title }}</h3>
      </v-toolbar-title>
      <v-spacer/>
      <v-btn icon dark @click="HIDDE_DIALOG_ALERT_MAIN()" color="black">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card tile>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <p class="text-justify">
              {{ message }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-end>
        <v-btn
          class="mr-3"
          color="#d68110"
          depressed
          outlined
          @click="onCancel">Cerrar</v-btn>
      </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: ['message'],
  data: () => ({
  }),
  components: {},
  mounted () {
  },
  methods: {
    ...mapActions(['PostObject', 'PutObject']),
    onCancel () {
      this.HIDDE_DIALOG_ALERT_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_ALERT_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogAlertMain'])
  },
  watch: {}
}
</script>

<style scoped>
.text-color-main{
  color: #026270;
}
</style>
